import { render, staticRenderFns } from "./CreateCommunity.vue?vue&type=template&id=7fd34077&scoped=true&"
import script from "./CreateCommunity.vue?vue&type=script&lang=js&"
export * from "./CreateCommunity.vue?vue&type=script&lang=js&"
import style0 from "./CreateCommunity.vue?vue&type=style&index=0&id=7fd34077&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd34077",
  null
  
)

export default component.exports